module.exports = __webpack_public_path__ + "img/rspca.d5b3042.jpg";